import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@storable/canaveral-components';
import OverlayButton from '../../../src/admin/layout/components/OverlayButton';
import styles from './styles.scss';
import { LAYOUT, PAGE } from './constants';

const propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  unauthorized: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([LAYOUT, PAGE]).isRequired,
};

const defaultProps = {
  className: undefined,
  disabled: undefined,
  loading: undefined,
};

const PublishButton = ({
  className,
  disabled,
  onClick,
  loading,
  unauthorized,
  type,
}) => {
  const authText = `You do not have permission to publish this ${type}`;

  const overlay = unauthorized ? (
    <div className={styles.unauthorized}>
      <Icon id="circle-lock" label="Unauthorized" />
      {authText}
    </div>
  ) : undefined;

  return (
    <OverlayButton
      size="sm"
      className={className}
      context="positive"
      icon="warning"
      disabled={disabled}
      onClick={onClick}
      loading={loading}
      overlayText={overlay}
    >
      Publish
    </OverlayButton>
  );
};
PublishButton.propTypes = propTypes;
PublishButton.defaultProps = defaultProps;

export default PublishButton;
